import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import Link, { LinkStyle, LinkType } from "@/components/common/link/link";
import css from "./product-footer.module.scss";
import { CtaHelpPanel } from "@/sanity/sanity.types";

interface IProductFooterProps {
  data: CtaHelpPanel;
}

const ProductFooter = (props: IProductFooterProps) => {
  const { data } = props;
  const { heading, primaryCta, subtext } = data;

  return (
    <GridRow>
      <GridColumn className={css.productFooter}>
        <h2 className={css.productFooterTitle}>{heading}</h2>
        <p className="mt-2">{subtext}</p>
        <Link
          className={`${css.productFooterLink} `}
          href={primaryCta?.link?.href ?? ""}
          linkType={LinkType.BUTTON}
          linkStyle={LinkStyle.SECONDARY}
        >
          {primaryCta?.link?.label}
        </Link>
      </GridColumn>
    </GridRow>
  );
};

export default ProductFooter;
